import { Order } from '@/api/admin-orders-types'
import { Container, ContainerHeader } from '@/components/base/container'
import { Copy } from '@/components/base/copy'
import { SectionRow } from '@/components/base/section-row'
import { StatusBadge } from '@/components/base/status-badge'
import { Text } from '@/components/base/text'
import { useI18n } from '@/i18n/i18n-react'

export const OrderSandStarSection = ({ order }: { order: Order }) => {
	const { L } = useI18n()
	const sandstar = order.metadataJson?.sandstar
	if (!sandstar) {
		return null
	}

	const wentToCloudReview = sandstar.cloudReview === 'Y'

	return (
		<Container className='divide-y divide-dashed'>
			<ContainerHeader heading={L.OrderDetail.SandStar.Title()} />
			<SectionRow
				title={L.OrderDetail.SandStar.CloudReview()}
				value={
					<StatusBadge color={wentToCloudReview ? 'orange' : 'green'}>
						{wentToCloudReview ? L.General.True() : L.General.False()}
					</StatusBadge>
				}
			/>
			{sandstar.machineName && (
				<SectionRow
					title={L.OrderDetail.SandStar.MachineName()}
					value={
						<div className='flex items-center gap-x-1'>
							<Text size='small' leading='compact'>
								{sandstar.machineName}
							</Text>
							<Copy content={sandstar.machineName} className='text-ui-fg-muted' />
						</div>
					}
				/>
			)}
			{sandstar.orderNo && (
				<SectionRow
					title={L.OrderDetail.SandStar.OrderNo()}
					value={
						<div className='flex items-center gap-x-1'>
							<Text size='small' leading='compact'>
								{sandstar.orderNo}
							</Text>
							<Copy content={sandstar.orderNo} className='text-ui-fg-muted' />
						</div>
					}
				/>
			)}
			{sandstar.abnormalReason && (
				<SectionRow title={L.OrderDetail.SandStar.AbnormalReason()} value={sandstar.abnormalReason} />
			)}
			<div className='px-3 py-2 sm:px-6 sm:py-4'>
				<Text size='small' weight='plus' leading='compact' className='mb-2 text-ui-fg-subtle'>
					{L.OrderDetail.SandStar.Video()}
				</Text>
				{sandstar.topVideoUrl ? (
					<video
						controls
						playsInline
						preload='metadata'
						src={sandstar.topVideoUrl}
						className='w-full max-w-lg rounded-md bg-ui-bg-subtle'
					/>
				) : (
					<Text size='small' className='text-ui-fg-muted'>
						{L.OrderDetail.SandStar.NoVideo()}
					</Text>
				)}
			</div>
		</Container>
	)
}
